module.exports = __webpack_public_path__ + "static/media/promo.7f962699.png";